import { useState } from "react";
import { useNavigate } from "react-router-dom";

import type { AnlegbareHerstellerArt } from "@repo/shared";

import { api, errorMessage } from "../../lib/api";

/** Name eingeben, anlegen – danach geht es direkt in die Bearbeitung des neuen Herstellers. */
export function NeuerHerstellerFormular({ art, onAbbrechen }: { art: AnlegbareHerstellerArt; onAbbrechen: () => void }) {
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [fehler, setFehler] = useState<string | null>(null);
  const [legtAn, setLegtAn] = useState(false);

  async function anlegen(event: React.FormEvent<HTMLFormElement>) {
    event.preventDefault();
    if (!name.trim()) {
      setFehler("Bitte einen Namen eintragen.");
      return;
    }
    setLegtAn(true);
    setFehler(null);
    try {
      const res = await api.api.admin.hersteller.$post({ json: { name: name.trim(), art } });
      if (!res.ok) throw new Error(await errorMessage(res, "Anlegen fehlgeschlagen"));
      const daten = await res.json();
      if ("hersteller" in daten) navigate(`/hersteller/${daten.hersteller.schluessel}`, { state: { bearbeiten: true } });
    } catch (cause) {
      setFehler(cause instanceof Error ? cause.message : "Anlegen fehlgeschlagen");
      setLegtAn(false);
    }
  }

  return (
    <form className="form" onSubmit={anlegen} noValidate>
      <label className="field">
        <span>Name des neuen Herstellers</span>
        <input value={name} onChange={(e) => setName(e.target.value)} maxLength={255} autoFocus />
        {fehler && <small className="error">{fehler}</small>}
      </label>
      <div className="actions">
        <button type="submit" className="primary" disabled={legtAn}>
          {legtAn ? "Legt an …" : "Anlegen"}
        </button>
        <button type="button" onClick={onAbbrechen} disabled={legtAn}>
          Abbrechen
        </button>
      </div>
    </form>
  );
}
